<template>
  <div v-if="params.data" class="user-actions" @click.stop>
    <button
      type="button"
      class="us-icon-btn"
      v-tooltip="{ content: 'Editar usuario', classes: 'cultura-tooltip', placement: 'top' }"
      aria-label="Editar"
      @click="parent.handleEdit(params.data)"
    >
      <i class="material-icons">edit</i>
    </button>
    <button
      v-if="parent.tokenUser && parent.tokenUser.admin"
      type="button"
      class="us-icon-btn"
      v-tooltip="{ content: 'Reenviar correo de contraseña', classes: 'cultura-tooltip', placement: 'top' }"
      aria-label="Reenviar correo de contraseña"
      :disabled="isResending"
      @click="parent.handleResend(params.data)"
    >
      <i class="material-icons">forward_to_inbox</i>
    </button>
    <button
      type="button"
      class="us-icon-btn is-danger"
      v-tooltip="{ content: 'Eliminar usuario', classes: 'cultura-tooltip', placement: 'top' }"
      aria-label="Eliminar"
      @click="parent.handleDelete(params.data)"
    >
      <i class="material-icons">delete</i>
    </button>
  </div>
</template>

<script>
export default {
  name: "UserActions",
  computed: {
    parent() {
      return this.params.context.componentParent;
    },
    isResending() {
      return (
        !!this.params.data &&
        this.parent.resendingIds.indexOf(this.params.data._id) > -1
      );
    },
  },
};
</script>

<style scoped>
.user-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/users/components/UserActions.vue